import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=460689f6&scoped=true&"
import script from "./AdminSection.vue?vue&type=script&lang=js&"
export * from "./AdminSection.vue?vue&type=script&lang=js&"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=460689f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460689f6",
  null
  
)

export default component.exports